<template>
  <div>Edit Publications</div>
</template>

<script>
export default {};
</script>